import Vue from 'vue'
import Router from 'vue-router'
import Layout from "@/views/layout/Layout";

import index from '@/views/index'

Vue.use(Router)

export let constRouter = [
	{
		path: '/',
		component: Layout,
		// name: 'index',
		redirect: "index",
		children: [
			{
				path: "index",
				meta: {
					title: '首页',
				},
				component: () => import("@/views/index/index"),
				name: "首页",
			}
		]
	},
	{
		path: '/searchPage/list',
		component: Layout,
		children: [
			{
				path: "",
				meta: {
					title: '搜索页',
				},
				component: () => import("@/views/searchPage"),
				name: "搜索页",
			}
		]
	},
	{
		path: '/searchPage/info/:id',
		component: Layout,
		children: [
			{
				path: "",
				meta: {
					title: '搜索详情页',
				},
				component: () => import("@/views/searchPageInfo"),
				name: "搜索详情页",
			}
		]
	},
]
export let routes = [
	...constRouter,


	// {
	// 	path: '/searchPage/:label',
	// 	component: Layout,
	// 	children: [
	// 		{
	// 			path: "",
	// 			meta: {
	// 				title: '搜索页',
	// 			},
	// 			component: () => import("@/views/searchPage"),
	// 			name: "首页",
	// 		}
	// 	]
	// },

]

let router = new Router({
	// mode: 'history',  // 不带#
	routes,
	// scrollBehavior(to, from, savedPosition) {
	// 	console.log('savedPosition', savedPosition)
	// 	if (savedPosition) {
	// 		return savedPosition
	// 	} else {
	// 		// return savedPosition
	// 		// console.log('to-------------', to)

	// 		console.log('--router indexTopHeight', window.sessionStorage.indexTopHeight)
	// 		if (window.sessionStorage.indexTopHeight) {
	// 			console.log('-----------', parseFloat(window.sessionStorage.indexTopHeight))
	// 			// return { x: 0, y: parseFloat(window.sessionStorage.indexTopHeight) }
	// 			return { x: 0, y: 200 }
	// 		} else {
	// 			setTimeout(() => {
	// 				let bannerH = getIndexTopH()
	// 				console.log('-0--router indexTopHeight', bannerH)
	// 				return { x: 0, y: bannerH }
	// 			}, 10)
	// 		}
	// 	}
	// },
})

// // 路由跳转
// router.beforeEach((to, from, next) => {
// 	console.log('beforeEach1111', to)
// 	let routerRes = window.sessionStorage.routerRes // 路由
// 	console.log('window.sessionStorage.routerRes', window.sessionStorage.routerRes)
// 	if (!routerRes) {
// 		findMenuColTree().then((res) => {
// 			window.sessionStorage.routerRes = JSON.stringify(res.data)
// 			let resObj = setRouter(res.data)
// 			window.sessionStorage.indexNavList = JSON.stringify(resObj.navList)
// 			router.addRoutes(resObj.addRoutersArr)
// 			// next({
// 			// 	...to,
// 			// 	replace: true
// 			// })
// 			next()
// 		})
// 	} else {
// 		let resObj = setRouter(JSON.parse(routerRes))
// 		console.log('resObj2222', resObj)
// 		window.sessionStorage.indexNavList = JSON.stringify(resObj.navList)
// 		router.addRoutes(resObj.addRoutersArr)
// 		next()
// 	}
// })
// // 拼接
// function setRouter(routerRes) {
// 	let addRoutersArr = []
// 	let navList = []
// 	for (let item of routerRes) {
// 		if (item.children.length == 0) {
// 			// 导航
// 			let navObj = {
// 				label: `${item.title}`,
// 				linkUrl: `/${item.keyWords}/list`,
// 			}
// 			navList.push(navObj)

// 			// 路由
// 			let routerObj = {
// 				path: `/${item.keyWords}`,
// 				component: Layout,
// 				redirect: `/${item.keyWords}/list`,
// 				children: [
// 					{
// 						path: 'list',
// 						name: `${item.title}`,
// 						meta: {
// 							title: `${item.title}`,
// 						},
// 						component: () => import('@/views/rightStrList'),
// 					},
// 					{
// 						path: 'info',
// 						name: `${item.title}详情`,
// 						meta: {
// 							title: `${item.title}详情`,
// 							hidden: true,
// 						},
// 						component: () => import('@/views/rightRichText'),
// 					},
// 				],
// 			}
// 			addRoutersArr.push(routerObj)
// 		} else {
// 			// 导航
// 			let navObj = {
// 				label: `${item.title}`,
// 				linkUrl: `/${item.keyWords}`,
// 			}
// 			navList.push(navObj)
// 			// 路由
// 			let routerObj1 = {
// 				path: `/${item.keyWords}`,
// 				component: Layout,
// 				meta: {
// 					title: `${item.title}`,
// 				},
// 				name: `${item.title}`,
// 				redirect: `/${item.keyWords}/${item.children[0].keyWords}/list`,
// 				children: [],
// 			}
// 			for (let itemChildren of item.children) {
// 				let listObj = {
// 					path: `${itemChildren.keyWords}/list`,
// 					name: `${itemChildren.title}`,
// 					meta: {
// 						title: `${itemChildren.title}`,
// 					},
// 					component: () => import('@/views/rightStrList'),
// 				}
// 				let infoObj = {
// 					path: `${itemChildren.keyWords}/info`,
// 					name: `${itemChildren.title}详情`,
// 					meta: {
// 						title: `${itemChildren.title}详情`,
// 					},
// 					component: () => import('@/views/rightRichText'),
// 				}
// 				routerObj1.children.push(listObj)
// 				routerObj1.children.push(infoObj)
// 			}
// 			addRoutersArr.push(routerObj1)
// 		}
// 	}
// 	return {
// 		addRoutersArr,
// 		navList
// 	}

// }



export default router



// WEBPACK FOOTER //
// ./src/router/index.js